import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import { SQUARE_LOCATION_URL, SQUARE_SYNC } from '../../const/URL.const';
import ESquareRedirectCode from '../../interfaces/ESquareRedirectCode';

const SquareOAuthRedirect = () => {
    const { search } = useLocation();
    const history = useHistory();
    const stateToken = new URLSearchParams(search).get("state");

    useEffect(() => {
        const origin = stateToken?.split('_')[0] as ESquareRedirectCode;
        switch(origin){
            case ESquareRedirectCode.SIGNUP:
                history.push({
                    pathname: SQUARE_LOCATION_URL,
                    search
                })
                break;
            case ESquareRedirectCode.REAUTH:
                history.push({
                    pathname: SQUARE_SYNC,
                    search
                })
            break;             
        }
        //eslint-disable-next-line
    }, [stateToken]);
    return null;
}

export default SquareOAuthRedirect;